import { Inject, Injectable } from '@angular/core';
import { AppParametersService, BaseAppParameters, ENV } from '@immosky/types';
import { SearchSubscriptionEnvironmentConfig } from '../../environments/search-subscription-environment-config';

export interface SearchSubscriptionAppParametersInput
  extends BaseAppParameters {
  objectSearchUrl: string;
}

export interface SearchSubscriptionAppParameters extends BaseAppParameters {
  objectSearchUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class SearchSubscriptionAppParametersService extends AppParametersService<SearchSubscriptionAppParameters> {
  protected parameters: SearchSubscriptionAppParameters = {
    objectSearchUrl: this.environment.objectSearchUrl,
    apiBaseUrl: this.environment.apiBaseUrl,
    apiBasicAuth: this.environment.apiBasicAuth,
    language: this.environment.language,
    countries: this.environment.countries,
    propertiesIndex: 'properties-staging',
    regionsIndex: 'regions-staging',
    branding: 'immosky',
    isResidia: false,
  };

  constructor(
    @Inject(ENV) protected environment: SearchSubscriptionEnvironmentConfig
  ) {
    super(environment);
  }

  protected setAppParameters(
    inputConfig: SearchSubscriptionAppParametersInput
  ): void {
    if (inputConfig.objectSearchUrl) {
      this.parameters.objectSearchUrl = inputConfig.objectSearchUrl;
    }
    if (inputConfig.countries) {
      this.parameters.countries = inputConfig.countries;
    }
    if (inputConfig.propertiesIndex) {
      this.parameters.propertiesIndex = inputConfig.propertiesIndex;
    }
    if (inputConfig.regionsIndex) {
      this.parameters.regionsIndex = inputConfig.regionsIndex;
    }
    if (inputConfig.apiBaseUrl) {
      this.parameters.apiBaseUrl = inputConfig.apiBaseUrl;
    }
    if (inputConfig.apiBasicAuth) {
      this.parameters.apiBasicAuth = inputConfig.apiBasicAuth;
    }
    if (inputConfig.language) {
      this.parameters.language = inputConfig.language;
    }
    if (inputConfig.searchSubscriptionNewsletterSignupUrl) {
      this.parameters.searchSubscriptionNewsletterSignupUrl =
        inputConfig.searchSubscriptionNewsletterSignupUrl;
    }
    if (inputConfig.propertiesIndex) {
      this.parameters.propertiesIndex = inputConfig.propertiesIndex;
    }
    if (inputConfig.regionsIndex) {
      this.parameters.regionsIndex = inputConfig.regionsIndex;
    }
    if (inputConfig.branding) {
      this.parameters.branding = inputConfig.branding;
    }
  }
}
